module.exports = __webpack_public_path__ + "static/media/manguera-roja.eb2c8d83.svg";